import * as Sentry from '@sentry/angular';
import { browserTracingIntegration } from '@sentry/angular';
import { escapeRegExp } from 'lodash';

/**
 * Setup Sentry using the DSN that has been applied to the window.
 */
export function initialiseSentry() {
    // @ts-ignore - no type sensing available
    const constants = window.appConfig;
    const API_URL =
        constants.API_URL || constants.SITE_URL || window.location.origin;
    const escapedUrl = new RegExp(escapeRegExp(API_URL));
    // @ts-ignore - no type sensing available
    if (window.sentryDsn != null) {
        try {
            Sentry.init({
                // @ts-ignore
                dsn: window.sentryDsn,
                // @ts-ignore
                environment: window.sentryEnv,
                // @ts-ignore this is set by webpack
                release: release.identifier || 'dev',
                ignoreErrors: [/"status":401/],
                integrations: [browserTracingIntegration()],
                tracesSampleRate: 0.1,
                tracePropagationTargets: ['localhost', escapedUrl]
            });
        } catch (e) {
            window.console.warn(e);
        }
    }
}
